import React, {useEffect, useRef, useState} from 'react';
import {CardElement, Elements, injectStripe, StripeProvider} from 'react-stripe-elements';
import {ControlLabel, FormControl, FormGroup, Row} from "react-bootstrap";
import './StripeCardRegister.css'

const createOptions = () => {
    return {
        style: {
            base: {
                width: '100%',
                fontSize: '16px',
                color: '#424770',
                fontFamily: 'Open Sans, sans-serif',
                letterSpacing: '0.025em',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#c23d4b',
            }
        }
    }
};

const _CardForm = ({stripe, setIsValidCard, setStripePaymentMethod, setStripeClient, loading}) => {
    const [name, setName] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const [isCompleted, setIsCompleted] = useState(false)
    const cardElement = useRef()

    useEffect(() => setStripeClient(stripe), [stripe])

    const handleNameChange = (e) => {
        setName(e.target.value)
        if (isCompleted && e.target.value.length > 0) {
            setIsValidCard(true)
        } else {
            setIsValidCard(false)
        }
    }
    const handleCardChange = async (e) => {
        if (e.complete) {
            const {error, paymentMethod} = await stripe.createPaymentMethod('card', cardElement.current._element);
            if (error) {
                setErrorMessage(error.message)
            } else {
                setStripePaymentMethod(paymentMethod)
                setIsCompleted(true)
                setIsValidCard(name.length > 0)
            }
        } else {
            setIsCompleted(false)
            setIsValidCard(false)
        }
        e.error ? setErrorMessage(e.error.message) : setErrorMessage('')
    }
    const generateSubscriptionNameField = () =>
        <FormGroup bsSize="medium" className='credential_input'>
            <ControlLabel className='d-flex'>
                <p className='bold bottom0'><span className='colorRed mr-3'>*</span>FULL NAME</p>
            </ControlLabel>
            <FormControl
                type='text'
                placeholder='First and last name'
                value={name}
                onChange={e => handleNameChange(e)}
                disabled={loading}
            />
        </FormGroup>

    const generateCardNumberField = () =>
        <FormGroup bsSize="small" className='credential_input'>
            <ControlLabel className='d-flex'>
                <p className='bold bottom0'><span className='colorRed mr-3'>*</span>CARD</p>
            </ControlLabel>
            <CardElement
                ref={cardElement}
                onChange={(e) => handleCardChange(e)}
                {...createOptions()}
                disabled={loading}
            />
        </FormGroup>

    return (
        <div className="CardSubscritionDemo">
            <form>
                <Row className='textCenter mt-40'>
                    {generateSubscriptionNameField()}
                </Row>
                <Row className='textCenter mt-40'>
                    {generateCardNumberField()}
                </Row>
                <Row className='textCenter'>
                    <div className="error text-danger" role="alert">
                        <strong>{errorMessage}</strong>
                    </div>
                </Row>
            </form>
        </div>
    );
}

const CardForm = injectStripe(_CardForm);

export const PaymentElement = ({setIsValidCard, setStripePaymentMethod, setStripeClient, loading, stripePublishableKey}) => (
    <StripeProvider apiKey={stripePublishableKey}>
        <Elements>
            <CardForm
                setIsValidCard={setIsValidCard}
                setStripePaymentMethod={setStripePaymentMethod}
                setStripeClient={setStripeClient}
                loading={loading}
            />
        </Elements>
    </StripeProvider>
);
